export const payments = {
  title: `Betalingen`,
};